module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchTerm),
      expression: "searchTerm",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.searchTerm
    },
    attrs: {
      "type": "text",
      "id": "google_places_search",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.selectedLocation.name && _vm.confirmationMessage.length) ? _c('div', {
    staticClass: "margin-bottom-5 margin-left-15"
  }, [_c('small', {
    domProps: {
      "innerHTML": _vm._s(_vm.confirmationMessage)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.selectedLocation.name) ? _c('div', {
    staticClass: "col-xs-12 blog-page blog-content-1"
  }, [_c('div', {
    staticClass: "blog-post-xs bordered blog-container"
  }, [_c('div', {
    staticClass: "blog-img-thumb"
  }, [_c('img', {
    attrs: {
      "src": _vm.selectedLocation.main_photo
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "blog-post-content"
  }, [_c('h2', {
    staticClass: "blog-title blog-post-title"
  }, [_c('a', [_vm._v(_vm._s(_vm.selectedLocation.name))])]), _vm._v(" "), _c('p', {
    staticClass: "font-grey-mint",
    domProps: {
      "innerHTML": _vm._s(_vm.selectedLocation.adr_address)
    }
  }), _vm._v(" "), (_vm.selectedLocation.formatted_phone_number) ? _c('p', {
    staticClass: "font-grey-mint"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" " + _vm._s(_vm.selectedLocation.formatted_phone_number))]) : _vm._e(), _vm._v(" "), (_vm.selectedLocation.website) ? _c('p', {
    staticClass: "font-grey-mint"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.selectedLocation.website,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.selectedLocation.website))])]) : _vm._e()])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "google_places_search"
    }
  }, [_vm._v("Search for your location "), _c('small', {
    staticClass: "font-grey-cascade"
  }, [_vm._v("(Make sure your location is set up on Google.)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b6c37c70!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/GooglePlacesSearch.vue
// module id = 454
// module chunks = 1